import { render } from "./ConnectionDetails.vue?vue&type=template&id=26de146b"
import script from "./ConnectionDetails.vue?vue&type=script&lang=js"
export * from "./ConnectionDetails.vue?vue&type=script&lang=js"

import "./ConnectionDetails.vue?vue&type=style&index=0&id=26de146b&lang=scss"

import exportComponent from "/app/tmp/ardia/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__